

import FmdGoodIcon from '@mui/icons-material/FmdGood';
import S from './SingleDam.module.css'
import Y from './ListDam.module.css'

import {  Edit, Key, Sensors, Settings } from '@mui/icons-material'
import ReportIcon from '@mui/icons-material/Report';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useEffect, useState } from 'react'
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ModelTrainingIcon from '@mui/icons-material/ModelTraining';


import G from '../images/term.svg'

import apiService from '../api/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import {  useParams } from 'react-router-dom';
import AddTerminal from '../Components/AddTerminalModal';
import { useGlobalContext } from '../Components/Context';
import { updateTerminal } from '../redux/slices/adminSlice';
import { Switch } from '@mui/material';
const moment=require('moment-jalaali');

const TerminalSingle=()=>{
    const {currentTerminal}=useSelector(state=>state.p.admin)
    const {id}=useParams()
    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();
    const dispatch=useDispatch()
    const getTerminals=async()=>{
        
            const res=await apiService.getTerminal(id)
            dispatch(updateTerminal(res.data))
    }
    const toggle=async()=>{
        const res=await apiService.toggleTerminal(id)
            dispatch(updateTerminal(res.data))
    }
    useEffect(()=>{
        getTerminals();
    },[])
 
    return <>
    <div className={S.SingleDamCon}>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
    <div className={S.SingleDamTitleCon}>
    <img style={{width:'72px',height:'72px'}} className={S.SingleDamimgTit} src={G}/>
        <h2> ترمینال </h2>
        </div>
        <div onClick={openModalls} className={S.EditBtnTableDam}>
                <Edit sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
    </div>

        <hr/>
        <div className={Y.AnimContentLI}>
        <table >
            <thead>
            <tr>
            <th className={S.LogoFormT}><div><span>
                    <ReportIcon/></span></div></th>
                    
               
                    
                    <th className={S.LogoFormT}><div><span><Sensors/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <ModelTrainingIcon/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <FmdGoodIcon/></span></div></th>
                    <th className={S.LogoFormT}><div><span>
                    <AccessTimeIcon/></span></div></th>
                    

                </tr>
            </thead>
            <tbody style={{margin:'0px auto'}}>
                
                <tr>
                <td className={S.TableFormTit}>فعال / غیر فعال</td>
                
                    
                    
                    <td className={S.TableFormTit}>کد دستگاه </td>
                    <td className={S.TableFormTit}> ورژن </td>
                    <td className={S.TableFormTit}>محل نصب </td>
                    <td className={S.TableFormTit}>زمان ایجاد </td>

                </tr>
                
                    <tr>
                    <td >
                <Switch color="success" checked={currentTerminal?.isActive} onChange={()=>toggle()} />

                    </td>
                    <td>{currentTerminal?.deviceCode}</td>
                    <td>{currentTerminal?.version?currentTerminal?.version:'---'}</td>
                    <td>{currentTerminal?.installedLocation}</td>
                    <td>{currentTerminal&&moment(currentTerminal&&currentTerminal?.createAt).format('jYYYY-jMM-jDD HH:mm')}</td>

                </tr>
               
               
            </tbody>
        </table>
        </div>
        <div className='specsss' style={{display:'flex',gap:'18px',textAlign:'center',alignItems:'center',borderRight:'3px solid green' ,marginTop:'16px'}}>
          <div className='d-flex gap-1 align-items-center'>
          <div className='LogoFormT'>
          <div ><span>
                <Settings/>
                </span>
                    </div>
          </div>
                    <div className={S.TableFormTit}>   مشخصات </div>

          </div>
          <div>{currentTerminal?.specs}</div>
        </div>
        
            


    </div>
    {isOpenModal&&<AddTerminal flag={'edit'} data={currentTerminal}/>}
    </>
}

export default TerminalSingle